// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-of-service-page {
    min-height: 100vh;
    padding: 40px 20px;
    background-color: #f8f9fa;
    font-family: 'Noto Sans KR', sans-serif;
}

.terms-container {
    max-width: 800px;
    margin: 0 auto;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.terms-header {
    background-color: #E84100;
    color: white;
    padding: 30px;
    text-align: center;
}

.terms-header h1 {
    margin: 0 0 10px 0;
    font-size: 28px;
    font-weight: 600;
}

.terms-subtitle {
    margin: 0;
    font-size: 16px;
    opacity: 0.9;
}

.terms-content {
    padding: 40px;
    line-height: 1.8;
    color: #333;
}

.terms-section {
    margin-bottom: 40px;
    padding-bottom: 30px;
    border-bottom: 1px solid #eee;
}

.terms-section:last-child {
    border-bottom: none;
    margin-bottom: 0;
}

.terms-section h2 {
    color: #E84100;
    font-size: 20px;
    font-weight: 600;
    margin: 0 0 20px 0;
    padding-bottom: 10px;
    border-bottom: 2px solid #E84100;
}

.terms-section h3 {
    color: #333;
    font-size: 16px;
    font-weight: 600;
    margin: 20px 0 10px 0;
}

.terms-section p {
    margin: 15px 0;
    text-align: justify;
}

.terms-section ul {
    margin: 15px 0;
    padding-left: 25px;
}

.terms-section li {
    margin: 8px 0;
    list-style-type: disc;
}

.terms-footer {
    padding: 20px;
    text-align: center;
    background-color: #f8f9fa;
    border-top: 1px solid #eee;
}

.close-button {
    padding: 12px 30px;
    background-color: #6c757d;
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.close-button:hover {
    background-color: #5a6268;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
    .terms-of-service-page {
        padding: 20px 10px;
    }

    .terms-container {
        margin: 0 10px;
    }

    .terms-header {
        padding: 20px;
    }

    .terms-header h1 {
        font-size: 24px;
    }

    .terms-content {
        padding: 20px;
    }

    .terms-section h2 {
        font-size: 18px;
    }

    .terms-section {
        margin-bottom: 30px;
        padding-bottom: 20px;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/TermsOfService.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,YAAY;AACZ;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;AACJ","sourcesContent":[".terms-of-service-page {\n    min-height: 100vh;\n    padding: 40px 20px;\n    background-color: #f8f9fa;\n    font-family: 'Noto Sans KR', sans-serif;\n}\n\n.terms-container {\n    max-width: 800px;\n    margin: 0 auto;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n}\n\n.terms-header {\n    background-color: #E84100;\n    color: white;\n    padding: 30px;\n    text-align: center;\n}\n\n.terms-header h1 {\n    margin: 0 0 10px 0;\n    font-size: 28px;\n    font-weight: 600;\n}\n\n.terms-subtitle {\n    margin: 0;\n    font-size: 16px;\n    opacity: 0.9;\n}\n\n.terms-content {\n    padding: 40px;\n    line-height: 1.8;\n    color: #333;\n}\n\n.terms-section {\n    margin-bottom: 40px;\n    padding-bottom: 30px;\n    border-bottom: 1px solid #eee;\n}\n\n.terms-section:last-child {\n    border-bottom: none;\n    margin-bottom: 0;\n}\n\n.terms-section h2 {\n    color: #E84100;\n    font-size: 20px;\n    font-weight: 600;\n    margin: 0 0 20px 0;\n    padding-bottom: 10px;\n    border-bottom: 2px solid #E84100;\n}\n\n.terms-section h3 {\n    color: #333;\n    font-size: 16px;\n    font-weight: 600;\n    margin: 20px 0 10px 0;\n}\n\n.terms-section p {\n    margin: 15px 0;\n    text-align: justify;\n}\n\n.terms-section ul {\n    margin: 15px 0;\n    padding-left: 25px;\n}\n\n.terms-section li {\n    margin: 8px 0;\n    list-style-type: disc;\n}\n\n.terms-footer {\n    padding: 20px;\n    text-align: center;\n    background-color: #f8f9fa;\n    border-top: 1px solid #eee;\n}\n\n.close-button {\n    padding: 12px 30px;\n    background-color: #6c757d;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.close-button:hover {\n    background-color: #5a6268;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 768px) {\n    .terms-of-service-page {\n        padding: 20px 10px;\n    }\n\n    .terms-container {\n        margin: 0 10px;\n    }\n\n    .terms-header {\n        padding: 20px;\n    }\n\n    .terms-header h1 {\n        font-size: 24px;\n    }\n\n    .terms-content {\n        padding: 20px;\n    }\n\n    .terms-section h2 {\n        font-size: 18px;\n    }\n\n    .terms-section {\n        margin-bottom: 30px;\n        padding-bottom: 20px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
